/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthorizationSessionResponse } from '../models/AuthorizationSessionResponse';
import type { LinkTrainerRequest } from '../models/LinkTrainerRequest';
import type { LinkTrainerResponse } from '../models/LinkTrainerResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuthorizationService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get current session user
     * @returns AuthorizationSessionResponse Session user or null
     * @throws ApiError
     */
    public getAuthorizationSession(): CancelablePromise<AuthorizationSessionResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authorization/session',
        });
    }

    /**
     * Link a newly signed-up user to their trainer
     * @returns LinkTrainerResponse Link successful or already exists
     * @throws ApiError
     */
    public postAuthorizationLinkTrainer({
        requestBody,
    }: {
        requestBody?: LinkTrainerRequest,
    }): CancelablePromise<LinkTrainerResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authorization/link-trainer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Not authenticated`,
            },
        });
    }

}
